module.exports = __webpack_public_path__ + "static/img/redmiBook13.30c98afb.png";